import { FunctionComponent, useEffect, useState } from "react"
import React from "react"
import { Button, Card, Col, Divider, Form, Input, notification, Row, Space, Spin, Typography } from "antd"
import { getColor } from "../utils"
import { MarketsService } from "../api/services.gen"
import { MarketWithInstrumentCount } from "../api"

interface MarketsPageProps {
}

const MarketsPage: FunctionComponent<MarketsPageProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [markets, setMarkets] = useState<MarketWithInstrumentCount[]>([])

  const fetchMarkets = async () => {
    setLoading(true)
    try {
      const response = await MarketsService.listMarkets()
      setMarkets(response.markets)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchMarkets()
  }, [])

  if (loading) {
    return <>
      <h2>Markets</h2>
      <Space>
        <Spin />
      </Space>
    </>
  }
  
  return <>
    <h2>Markets</h2>
    <Space>
      <Col>
        <Row gutter={[16, 16]}>
          {
            markets.length === 0 ? <p>No market</p> : markets?.map(market => <Col><Card style={{
              backgroundColor: getColor(market.id) + '20',
              borderColor: getColor(market.id) + '60',
            }} title={market.id}>
              <Typography.Text strong>{market.name}</Typography.Text>
              <Typography>Instruments: {market.instrumentsCount}</Typography>
            </Card></Col>)
          }
        </Row>
        <Divider />
        <AddMarket onFinish={() => {
          fetchMarkets()
        }} />
      </Col>
    </Space>
  </>
}

const AddMarket: FunctionComponent<{ onFinish: () => void }> = ({ onFinish, }) => {
  const [form] = Form.useForm()

  const create = async (values: any) => {
    try {
      const res = await MarketsService.addMarket({
        requestBody: {
          id: values.id,
          name: values.name,
          timezone: 'UTC',
        }
      })
      notification.success({
        message: 'Market added',
        description: 'Yihaaa'
      })
    } catch (e: any) {
      console.error(e)
      notification.error({
        message: 'Error',
        description: (e as any).toString()
      })
    }

    onFinish()
  }

  return <Form form={form} onFinish={create}>
    <Form.Item name="id" label='ID'>
      <Input placeholder="XPAR" />
    </Form.Item>
    <Form.Item name="name" label='Name'>
      <Input placeholder="Euronext Paris" />
    </Form.Item>

    <Form.Item>
     <Button type="primary" htmlType="submit">
        Create
      </Button>
     </Form.Item>
  </Form>
}

export { MarketsPage }